function getStepMainSelectors(state) {
  return {
    formValues: {
      operationType: state.stepMainProf.formValues.operationType,
      propertyType: state.stepMainProf.formValues.propertyType,
      propertyTypeName: state.stepMainProf.formValues.propertyTypeName,
      propertySubType: state.stepMainProf.formValues.propertySubType,
      propertySubTypeName: state.stepMainProf.formValues.propertySubTypeName
    },
    propertyTypesMostUsedOptions: state.stepMainProf.propertyTypesMostUsedOptions,
    propertyTypeOptions: state.stepMainProf.propertyTypeOptions,
    propertyTypesError: state.stepMainProf.propertyTypesError,
    propertyTypesLoading: state.stepMainProf.propertyTypesLoading,
    propertyTypesCompleted: state.stepMainProf.propertyTypesCompleted,

    propertySubTypeOptions: state.stepMainProf.propertySubTypeOptions,
    propertySubTypeError: state.stepMainProf.propertySubTypeOptionsError,
    propertySubTypeLoading: state.stepMainProf.propertySubTypeOptionsLoading,
    propertySubTypeCompleted: state.stepMainProf.propertySubTypeOptionsCompleted,

    formValuesError: state.stepMainProf.formValuesError,
    formValuesLoading: state.stepMainProf.formValuesLoading,
    formValuesCompleted: state.stepMainProf.formValuesCompleted
  };
}

export { getStepMainSelectors };
